'use client';

const loadingStartMsg = "Loading options";
const emptyLabel = "No options available";
export {
  emptyLabel,
  loadingStartMsg
};
